import React, { useEffect, useMemo, useState } from 'react';

function normalizeOptions(rows, labelField, valueField) {
  return (rows || []).map(function (row, index) {
    if (!row || typeof row !== 'object') {
      return {
        label: String(row),
        value: String(row)
      };
    }

    var labelKey = labelField || 'name';
    var valueKey = valueField || 'id';

    var label =
      row[labelKey] !== undefined
        ? row[labelKey]
        : row.Name !== undefined
          ? row.Name
          : row.name !== undefined
            ? row.name
            : 'Option ' + String(index + 1);

    var value =
      row[valueKey] !== undefined
        ? row[valueKey]
        : row.Oid !== undefined
          ? row.Oid
          : row.oid !== undefined
            ? row.oid
            : label;

    return {
      label: String(label),
      value
    };
  });
}

export default function DropdownFilterWidget({
  widget,
  adapter,
  mergedParams,
  onFilterChange,
  setFilterParam
}) {
  var [options, setOptions] = useState([]);
  var [selectedValue, setSelectedValue] = useState('');

  var filterName = widget.filterName || (widget.data && widget.data.filterName) || '';

  var labelField = widget.labelField || (widget.data && widget.data.labelField);
  var valueField = widget.valueField || (widget.data && widget.data.valueField);

  var localOptions = useMemo(function () {
    if (!Array.isArray(widget.options)) {
      return null;
    }

    return widget.options.map(function (option) {
      if (!option || typeof option !== 'object') {
        return { label: String(option), value: option };
      }

      return {
        label: option.label || option.name || option.Name || String(option.value || option.id),
        value: option.value !== undefined ? option.value : option.id
      };
    });
  }, [widget.options]);

  useEffect(
    function loadOptions() {
      var cancelled = false;

      async function load() {
        if (localOptions) {
          setOptions(localOptions);
          return;
        }

        if (!adapter) {
          setOptions([]);
          return;
        }

        try {
          var rows = [];

          if (widget.sourceType === 'table' && widget.sourceName) {
            var tableResult = await adapter.queryTable(widget.sourceName, widget.optionalWhere || {});
            rows = adapter.normalizeProcedureResult(tableResult);
          } else if (widget.procedureName) {
            var procResult = await adapter.executeProcedure(widget.procedureName, mergedParams || {});
            rows = adapter.normalizeProcedureResult(procResult);
          }

          if (!cancelled) {
            setOptions(normalizeOptions(rows, labelField, valueField));
          }
        } catch (error) {
          if (!cancelled) {
            setOptions([]);
          }
        }
      }

      load();
      return function cleanup() {
        cancelled = true;
      };
    },
    [adapter, widget, mergedParams, localOptions, labelField, valueField]
  );

  return (
    <div className="re-filter-body">
      <select
        value={selectedValue}
        onChange={function onChange(event) {
          var value = event.target.value;
          setSelectedValue(value);

          if (setFilterParam && filterName) {
            setFilterParam(filterName, value || null);
          } else if (onFilterChange) {
            onFilterChange(value || null);
          }
        }}
      >
        <option value="">All</option>
        {options.map(function (option) {
          return (
            <option key={String(option.value)} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
}
